import { getApis } from '../../library/Apis';
import { toRequest } from '../../utils/RequestUtils';

const getUsuarioEndpoint = () => {
  return getApis().apis.bff + 'v1/usuario/';
};

export const trocarSenha = (data, callbackSuccess, callbackError) => {
  return () => {
    toRequest(
      'put',
      [getUsuarioEndpoint() + 'trocar-senha', data],
      'save'
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
